export default {"src":"/_next/static/media/gradient_statistics.442ea5be.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};